import ls from "local-storage";
import store from "@/store";
const requireAuth = (to, from, next) => {
  let path = to.path;
  let split = path.split("/");
  store.dispatch("setPath", split[1]);
  store.dispatch("setFullPath", path);
  let token = ls.get("authen");
  if (!token) {
    next({
      path: "/login",
    });
  } else {
    next();
  }
};

const requireAuthV2 = (to, from, next) => {
  let path = to.path;
  let split = path.split("/");
  store.dispatch("setPath", split[1]);
  store.dispatch("setFullPath", path);
  next();
};

const requireAnyPermission = (requiredPermissions) => {
  return async (to, from, next) => {
    let path = to.path;
    let split = path.split("/");
    store.dispatch("setPath", split[1]);
    store.dispatch("setFullPath", path);

    let token = ls.get("authen");
    if (!token) {
      next({ path: "/login" });
      return;
    }

    try {
      let accountInfo = store.getters["account/accountInfo"];
      if (!Array.isArray(accountInfo.permissions)) {
        await store.dispatch("account/getAccountInfo");
        accountInfo = store.getters["account/accountInfo"];
      }

      const permissions = (accountInfo.permissions || []).map(
        permission => permission.name
      );

      if (requiredPermissions.some(permission => permissions.includes(permission))) {
        next();
        return;
      }
    } catch (error) {
      // Backend vẫn là lớp bảo vệ cuối cùng khi không tải được thông tin quyền.
    }

    next({ path: "/" });
  };
};

export default {
  requireAuth,
  requireAuthV2,
  requireAnyPermission,
};
